//components
import React from 'react';
import Cookies from 'universal-cookie';
import PropTypes from 'prop-types';

import DeleteIcon from '@material-ui/icons/Delete';
import { withStyles } from '@material-ui/core/styles';
import {Typography,Modal,Button} from '@material-ui/core';

//controllers
import Alerta from '../../../../snackbars/.mixins/';
import Comunicados_Controller from '../../../../../../controllers/comunicado';
import Contatos_Controller from '../../../../../../controllers/contato';
import Log from '../../../../../../controllers/log';

//css
import Modal_RemoveCss from './Modal_Remove-css';
const styles = Modal_RemoveCss();

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

class SimpleModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      id: null
    };
    this.inputRef = React.createRef();
    this.child = React.createRef();
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen(id){
    this.setState({ open: true });
    this.setState({ id: id });
  };

  handleClose(){
    setTimeout(() => {
      this.setState({ open: false });
    }, 200);
  };

  async sendRemove(props){

    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {
      var path = props.props.pai.props.route.path;
      path = path.substring(0, path.length - 1);

      var r_dados = null;
      var j_r_dados = null;

      if (path.includes('contato'))
        r_dados = await Contatos_Controller.deleta(token,props.state.id);
      else
        r_dados = await Comunicados_Controller.deleta(token,props.state.id);
      
      j_r_dados = JSON.parse(r_dados.body);

      //auditoria
      var str = "Efetuada requisição para deletar "+this.props.pai.state.title+"! "
      +"Response:( Method: "+r_dados.res.request.method
      +", StatusCode: "+r_dados.res.statusCode
      +", Body: (limited 100chars)"+r_dados.body.substr(0,100)
      +" )";
      Log.info(token,str);

      if (r_dados.res.statusCode === 200)
        this.child.current.retorno(j_r_dados.message,'success');
      else
        this.child.current.retorno('Não foi possível remover '+this.props.pai.state.title+'!','error');
    } catch (error) {
      this.child.current.retorno('Não foi possível remover '+this.props.pai.state.title+'!','error');

      //auditoria
      var str = "Erro ao deletar "+this.props.pai.state.title+"! "
      +"Erro:( Message: "+error.message+", Stack: "+error.stack+" )";
      Log.error(token,str);
    }

    //fecha modal
    props.handleClose();

    //chama funcao do pai para atualizar a lista
    // props.props.pai.loadData(props.props.pai, null);
    location.reload();
      
  }

  render() {
    const { classes } = this.props;
    
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
        >
          <div style={getModalStyle()} className={classes.paper}>
            <Typography type="title" id="modal-title" className={classes.tituloModalRemove}>
                <DeleteIcon />
                Remover item
            </Typography>
            <Typography type="subheading" id="simple-modal-description">
              Deseja realmente remover esse item?
            </Typography>
            <br/>
            <div align="right">
                <Button className={classes.buttonCancelar} onClick={this.handleClose}>
                    Não
                </Button>
                <Button variant="contained" className={classes.buttonRemover} onClick={(e)=>{this.sendRemove(this)}}>
                    Sim
                </Button>
            </div>
            <SimpleModalWrapped />
          </div>
        </Modal>
        <Alerta ref={this.child}/>
      </div>
    );
  }
}

SimpleModal.propTypes = {
  classes: PropTypes.object.isRequired,
};


const SimpleModalWrapped = withStyles(styles)(SimpleModal);

export default SimpleModalWrapped;